// extracted by mini-css-extract-plugin
export default {"item":"ContactItem_item__gxreB","contact":"ContactItem_contact__C4k7V"};